import { Row, Col, Button, Card, Form } from 'react-bootstrap';
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";
import React, { useState, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form';
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Toast from 'react-bootstrap/Toast';

import secureLocalStorage from 'react-secure-storage';
import setting from '../../setting.json';
import Image from 'react-bootstrap/Image';
import { useNavigate, useLocation } from 'react-router-dom';

const schema = yup.object().shape({
});

const PaymentForm = () => {
    const navigate = useNavigate()
    const [add, setAdd] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [coursecList, setCoursecList] = useState([]);
    const [majorList, setMajorList] = useState([]);
    const [minorList, setMinorList] = useState([]);
    const [vo_courseList, setVo_courseList] = useState([]);
    const [curricularSubject, setCoCurricularSubject] = useState([]);


    const location = useLocation();
    const { id, name,mobile, email, application, father, order_id} = location.state || {};

    const {
        register,
        handleSubmit,
        reset,
        setError,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),

    })


    const [paymentMode, setPaymentMode] = useState('')
    const [amount, setAmount] = useState('')
    const [transactionNumber, setTransactionNumber] = useState('')
    const [screenshot, setScreenshot] = useState(null)

    const [toast, setToast] = useState()
    const toaster = useRef(null)

  




const handleRazorpay = () => {
  if (typeof window.Razorpay === 'undefined') {
    alert("Razorpay SDK not loaded.");
    return;
  }

 const options = {
  key: "rzp_live_4doEjSk91kjkBU",
  amount: parseInt(amount) * 100, // Amount in paise
  currency: "INR",
  name: "Acharya Chanakya Mahavidyalay",
  description: "Application Fee",


  prefill: {
    name: name || "Student",
    email: email,
    contact: mobile // ✅ Customer's phone number
  },
  
  handler: async function (response) {
    console.log("Payment Success:", response);

    const paymentId = response.razorpay_payment_id;

    const db = new FormData();
    db.append('trans_no', paymentId);
    db.append('order_id', order_id);
    db.append('amount', amount); // 🔁 Send dynamic amount

    const res = await fetch(setting.api + 'web/savePayment', {
      method: 'POST',
      body: db,
    });

    const result = await res.json();

    if (result.result === 'success') {
      navigate("/paymentSuccess", {
        state: { paymentId,name },
      });
    } else {
      alert('Payment saved but failed in server.', 'error');
    }
  },

};


  const rzp = new window.Razorpay(options);

  rzp.on('payment.failed', function (response) {
    console.log("Payment Failed:", response);

    navigate("/payment-failed", {
      state: {
        error: response.error.description,
      },
    });
  });

  rzp.open();
};





useEffect(() => {
  const script = document.createElement('script');
  script.src = 'https://checkout.razorpay.com/v1/checkout.js';
  script.async = true;
  document.body.appendChild(script);
}, []);



    return (
        <div className="student-page">
            <Header />
            <header className="height-75">
                <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
                    <h1 className="text-center fw-semibold">Payment Form</h1>
                </div>
            </header>

            <section className="teacher-section py-3 bg_img ">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="section-header">
                                <h3 className="title"><b>Payment Form</b></h3>
                            </div>
                        </div>
                    </div>
                    <div className="cart-checkout-box mb-widget"></div>


                    <Card style={{ maxWidth: '500px' }}>

                            {/* <div >
                        <div className="d-flex mb-2">
                            <div style={{ width: '150px', fontWeight: 'bold' }}>Name:</div>
                            <div>{name || '-'}</div>
                        </div>
                        <div className="d-flex mb-2">
                            <div style={{ width: '150px', fontWeight: 'bold' }}>Application No:</div>
                            <div>{application || '-'}</div>
                        </div>
                        <div className="d-flex">
                            <div style={{ width: '150px', fontWeight: 'bold' }}>Father's Name:</div>
                            <div>{father || '-'}</div>
                        </div>
                    </div>
                    <br /> */}

<Card.Body>
  <Form.Group className="mb-3" controlId="amount">
    <Form.Label>Enter Amount</Form.Label>
    <Form.Control
      type="number"
      placeholder="Enter amount"
      value={amount}
      onChange={(e) => setAmount(e.target.value)}
      required
    />
  </Form.Group>

  <Button
    onClick={handleRazorpay}
    variant="primary"
    className="w-100"
    disabled={!amount || parseInt(amount) <= 0}
  >
    Pay ₹{amount || '...'}
  </Button>
</Card.Body>

                    </Card >
                </div>
            </section >
            <Footer />
        </div >
    );
}
export default PaymentForm;